var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 144,
    viewBox: "0 0 512 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17378",
    "data-name": "Ret\\xE2ngulo 17378",
    width: 512,
    height: 144,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11657",
    "data-name": "Grupo 11657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11639",
    "data-name": "Grupo 11639"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17379",
    "data-name": "Ret\\xE2ngulo 17379",
    width: 93.26,
    height: 38.027,
    rx: 4,
    transform: "translate(309.066 96.717)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1363",
    "data-name": "Elipse 1363",
    cx: 10.699,
    cy: 10.699,
    r: 10.699,
    transform: "translate(317.613 105.031)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17380",
    "data-name": "Ret\\xE2ngulo 17380",
    width: 41.933,
    height: 4.753,
    transform: "translate(347.987 108.6)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17381",
    "data-name": "Ret\\xE2ngulo 17381",
    width: 31.087,
    height: 4.753,
    transform: "translate(347.987 118.107)",
    fill: "#d5d5d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11644",
    "data-name": "Grupo 11644"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1364",
    "data-name": "Elipse 1364",
    cx: 51.728,
    cy: 51.728,
    r: 51.728,
    transform: "translate(109.688 6.808)",
    fill: "#fc9702"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11643",
    "data-name": "Grupo 11643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11640",
    "data-name": "Grupo 11640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7281",
    "data-name": "Caminho 7281",
    d: "M150.576,56.689l-4.54-12,1.7-.646,4.54,12Z",
    fill: "#131313"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11641",
    "data-name": "Grupo 11641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7282",
    "data-name": "Caminho 7282",
    d: "M168.831,49.792l-4.54-12.008,1.7-.646,4.54,12.008Z",
    fill: "#131313"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11642",
    "data-name": "Grupo 11642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7283",
    "data-name": "Caminho 7283",
    d: "M160.515,79.934a28.587,28.587,0,0,1-26.728-18.45l1.7-.642a26.729,26.729,0,0,0,50.005-18.9l1.7-.643a28.55,28.55,0,0,1-26.671,38.636Z",
    fill: "#131313"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11652",
    "data-name": "Grupo 11652"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    cx: 30.579,
    cy: 30.579,
    r: 30.579,
    transform: "translate(217.152 76.641)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11651",
    "data-name": "Grupo 11651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11650",
    "data-name": "Grupo 11650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11645",
    "data-name": "Grupo 11645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7284",
    "data-name": "Caminho 7284",
    d: "M278.9,91.477l-.2-.747a4.236,4.236,0,0,0-5.057-3.194l-9.511,2.548h0c1.282-3.953,2.292-9.022,1.117-13.118a5.375,5.375,0,0,0-1.78-2.923c-1.619-1.182-3.876-.507-5.226.9s-2.046,3.373-2.852,5.209A35.685,35.685,0,0,1,243.129,95.29h0l7,28.243,16.1-4.314,1.331-.356,4-1.072,9.511-2.548a4.237,4.237,0,0,0,2.783-5.295l-.2-.747a4.236,4.236,0,0,0-5.057-3.194h0a4.236,4.236,0,0,0,2.782-5.3l-.2-.746a4.236,4.236,0,0,0-5.057-3.195h0A4.236,4.236,0,0,0,278.9,91.477Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7285",
    "data-name": "Caminho 7285",
    d: "M250.13,124.127a.593.593,0,0,1-.576-.451l-7-28.244a.593.593,0,0,1,.242-.634,35.21,35.21,0,0,0,12.057-14.883l.371-.863a14.512,14.512,0,0,1,2.6-4.518c1.462-1.528,4.064-2.389,6.005-.971a5.851,5.851,0,0,1,2,3.239c1.147,3.992.275,8.792-.8,12.43l8.47-2.27a4.837,4.837,0,0,1,5.786,3.614l.2.747a5.146,5.146,0,0,1-.392,3.739,4.724,4.724,0,0,1-.834,1.141,5.059,5.059,0,0,1,3.5,3.609l.2.747a5.057,5.057,0,0,1-1.229,4.875,4.689,4.689,0,0,1,1.294.571,5.145,5.145,0,0,1,2.209,3.042l.2.748a5.149,5.149,0,0,1-.392,3.738,4.471,4.471,0,0,1-2.81,2.284l-30.942,8.29A.614.614,0,0,1,250.13,124.127ZM243.8,95.545l6.757,27.258,30.356-8.134a3.293,3.293,0,0,0,2.067-1.689,3.955,3.955,0,0,0,.295-2.878l-.2-.748a3.96,3.96,0,0,0-1.7-2.344,3.292,3.292,0,0,0-2.633-.429.592.592,0,0,1-.729-.42.632.632,0,0,1-.02-.154.6.6,0,0,1,.44-.574,3.647,3.647,0,0,0,2.363-4.567l-.2-.747a3.647,3.647,0,0,0-4.33-2.774.594.594,0,0,1-.727-.42.632.632,0,0,1-.02-.154.6.6,0,0,1,.441-.574,3.3,3.3,0,0,0,2.066-1.687,3.96,3.96,0,0,0,.294-2.88h0l-.2-.747a3.648,3.648,0,0,0-4.33-2.774l-9.509,2.549a.594.594,0,0,1-.719-.757c1.155-3.565,2.286-8.675,1.11-12.771a4.725,4.725,0,0,0-1.559-2.607c-1.392-1.018-3.332-.332-4.446.833a13.631,13.631,0,0,0-2.361,4.161l-.377.876A36.537,36.537,0,0,1,243.8,95.545Z",
    fill: "#2f2f2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11646",
    "data-name": "Grupo 11646"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x1: 14.213,
    y2: 3.808,
    transform: "translate(262.63 96.653)",
    fill: "#fc9bbe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17382",
    "data-name": "Ret\\xE2ngulo 17382",
    width: 15.903,
    height: 1.188,
    transform: "translate(261.903 100.041) rotate(-15)",
    fill: "#2f2f2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11647",
    "data-name": "Grupo 11647"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_4",
    "data-name": "Linha 4",
    x1: 14.213,
    y2: 3.808,
    transform: "translate(265.048 105.676)",
    fill: "#fc9bbe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17383",
    "data-name": "Ret\\xE2ngulo 17383",
    width: 15.903,
    height: 1.188,
    transform: "translate(264.32 109.065) rotate(-15)",
    fill: "#2f2f2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11648",
    "data-name": "Grupo 11648"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_5",
    "data-name": "Linha 5",
    x1: 4.349,
    y2: 1.165,
    transform: "translate(260.137 89.991)",
    fill: "#fc9bbe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17384",
    "data-name": "Ret\\xE2ngulo 17384",
    width: 5.691,
    height: 1.188,
    transform: "translate(259.409 90.736) rotate(-15)",
    fill: "#2f2f2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11649",
    "data-name": "Grupo 11649"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17385",
    "data-name": "Ret\\xE2ngulo 17385",
    width: 10.121,
    height: 29.247,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 233.875, 97.687)",
    fill: "#97359e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7286",
    "data-name": "Caminho 7286",
    d: "M241.025,126.665l-7.878-29.4,10.924-2.927,7.877,29.4ZM234.6,98.107l7.263,27.1,8.628-2.312-7.262-27.1Z",
    fill: "#2f2f2f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11655",
    "data-name": "Grupo 11655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11653",
    "data-name": "Grupo 11653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7287",
    "data-name": "Caminho 7287",
    d: "M334.639,83.416a40.906,40.906,0,1,1,9.111-6.868l.256,1L347.7,91.317l-11.943-7.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7288",
    "data-name": "Caminho 7288",
    d: "M348.653,92.587l-14.034-8.481a41.5,41.5,0,1,1,9.791-7.379l.172.669Zm-13.994-9.861,1.412.89,10.671,6.432-3.651-13.681.24-.24a40.164,40.164,0,1,0-8.979,6.77Z",
    fill: "#2f2f2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11654",
    "data-name": "Grupo 11654"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1366",
    "data-name": "Elipse 1366",
    cx: 4.065,
    cy: 4.065,
    r: 4.065,
    transform: "translate(310.963 42.829)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1367",
    "data-name": "Elipse 1367",
    cx: 4.065,
    cy: 4.065,
    r: 4.065,
    transform: "translate(295.144 42.829)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1368",
    "data-name": "Elipse 1368",
    cx: 4.065,
    cy: 4.065,
    r: 4.065,
    transform: "translate(326.783 42.829)",
    fill: "#2f2f2f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11656",
    "data-name": "Grupo 11656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7289",
    "data-name": "Caminho 7289",
    d: "M257.544,42.454a16.466,16.466,0,0,0-14.806,17.975,16.469,16.469,0,0,0-17.987-14.805,16.468,16.468,0,0,0,14.818-17.976A16.465,16.465,0,0,0,257.544,42.454Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7290",
    "data-name": "Caminho 7290",
    d: "M242.147,60.487a15.9,15.9,0,0,0-17.339-14.272l-.114-1.182A15.876,15.876,0,0,0,238.978,27.7l1.182-.115a15.9,15.9,0,0,0,17.326,14.273l.115,1.182a15.873,15.873,0,0,0-14.272,17.327ZM229.216,45.2A17.128,17.128,0,0,1,242.3,55.97a17.117,17.117,0,0,1,10.77-13.084A17.11,17.11,0,0,1,240,32.119,17.116,17.116,0,0,1,229.216,45.2Z",
    fill: "#2f2f2f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFeedback);
export default __webpack_public_path__ + "static/media/illustration-feedback.2e113cf9560f499432f97cd78fa006bf.svg";
export { ForwardRef as ReactComponent };